import DashboardMainComponent from "@/features/dashboard/DashboardMainComponent";
import React from "react";

const DashboardPage = () => {
  return (
    <div>
      <DashboardMainComponent />
    </div>
  );
};

export default DashboardPage;
